/******************************************************************************
 *** MbrasChangeSearchDialog ** 변경 등록 조합원 조회
 *******************************************************************************/
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import TextBox from "@/js/common/ui/input/TextBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import Util from "@/js/common/Util";
import React from "react";
import AppContext from "@/js/common/AppContext";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";

const MbrasChangeSearchDialog = (props: any) => {
    const {setModalOpen, selectMember, } = props;

    const userInfo = useRecoilValue(Atom.userInfo);

    const [keyword , setKeyword ] = React.useState("");
    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd); // 상위조직코드(본부)
    const [ognzCd  , setOgnzCd  ] = React.useState<string>(userInfo.ognzCd.includes("000") ? "" : userInfo.ognzCd); // 조직코드(지부)
    const [dataArr , setDataArr ] = React.useState<any[]>([]);

    /**
     * 변경신청서 작성 가능 여부 확인
     */
    const checkWriteAvailable = (item: any) => {
        if (item.writeYn !== "N") return true;

        const atrzSeNm   = Util.getValToCode("MBRAS_ATRZ_SE_CD", item.mbrasAtrzSeCd);
        const atrzSttsNm = Util.getValToCode("ATRZ_STTS_CD", item.atrzSttsCd);

        AppContext.openAlert({
            title: "신청서 작성 불가",
            msg: `${atrzSeNm} 신청서가 ${atrzSttsNm} 상태입니다.`,
            icon: "warning",
        });

        return false;
    };

    const fldInfs: fldInfsProps[] = [
        { type: "seq" ,                            width:  50, headAlign: "center", dataAlign: "center", label: "No."         },
        { type: "text", fldNm: "mbrasId"         , width: 130, headAlign: "center", dataAlign: "center", label: "조합원 번호" },
        { type: "text", fldNm: "mbrasNm"         , width:  90, headAlign: "center", dataAlign: "center", label: "성명"         },
        { type: "code", fldNm: "mbrasJoinSttsCd" , width:  70, headAlign: "center", dataAlign: "center", label: "가입상태", catCode: "MBRAS_JOIN_STTS_CD" },
        { type: "text", fldNm: "upOgnzNm"        , width: 110, headAlign: "center", dataAlign: "center", label: "본부"         },
        { type: "text", fldNm: "ognzNm"          , width: 130, headAlign: "center", dataAlign: "center", label: "지부"         },
        { type: "code", fldNm: "lbrShpSeCd"      , width:  90, headAlign: "center", dataAlign: "center", label: "근로형태", catCode: "LBR_SHP_SE_CD" },
        { type: "el"  , fldNm: "writeYn"         , width:  90, headAlign: "center", dataAlign: "center", label: "등록", el: (item: any) => <span className={"ls06 " + (item.writeYn === "Y" ? "" : "fcE53935")}>{item.writeYn === "Y" ? "가능" : "불가"}</span> },
    ];

    React.useEffect(() => {
        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-search-list.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                upOgnzCd: upOgnzCd === "00" ? "" : upOgnzCd,
                ognzCd  : ognzCd === "00_000" ? "" : ognzCd,
            },
            onSuccessFn: (res: any) => {
                const list = res.result.list || [];
                setDataArr(list);
                AppContext.hideSpinner();
            },
        });
    }, [upOgnzCd, ognzCd]);

    return (
        <div className="w760 p15">
            <div className="dpFlx aiC jcSb mb10 h44">
                <div className="fm-b fs16 fc007bff ls1 fw700">
                    <span>변경 대상 조합원 목록</span>
                </div>

                <div className="dpFlx aiC gap10">
                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">성명</span>
                        <TextBox
                            value={keyword}
                            width={150}
                            height={36}
                            fontSize={14}
                            fontFamily="fm-c"
                            color="#333"
                            letterSpacing={-1}
                            borderColor="#ddd"
                            borderOnColor="#222"
                            borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 10px" }}
                            placeholder="성명 입력"
                            onChangeFunc={(text: string) => setKeyword(text)}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox
                            value={upOgnzCd}
                            width={140}
                            height={36}
                            fontSize={14}
                            fontFamily="fm-c"
                            color="#333"
                            letterSpacing={-1}
                            borderColor="#ddd"
                            borderOnColor="#222"
                            borderRadius={2}
                            background={userInfo.ognzCd === "00_000" ? "#fff" : "#F6F6F6"}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            paddingRight={8}
                            disabled={userInfo.ognzCd === "00_000" ? false : true}
                            onChangeFunc={(data: string) => {
                                setUpOgnzCd(data);
                                if (data === "00") {
                                    setOgnzCd("00_000");
                                } else {
                                    setOgnzCd("");
                                }
                            }}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w40 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox
                            value={ognzCd}
                            width={150}
                            height={36}
                            fontSize={14}
                            fontFamily="fm-c"
                            color="#333"
                            letterSpacing={-1}
                            borderColor="#ddd"
                            borderOnColor="#222"
                            borderRadius={2}
                            background={userInfo.ognzCd.includes("000") ? "#fff" : "#F6F6F6"}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getDownOrgCodeArray(upOgnzCd))}
                            placeholder="전체"
                            paddingRight={8}
                            disabled={!userInfo.ognzCd.includes("000")}
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                        />
                    </div>
                </div>
            </div>

            <GridTable
                tableInfo={{
                    tableHeadVsb : true,
                    styleType    : AdminGridStyle,
                    fldInfs      : fldInfs,
                    ordFld       : { name: "mbrasId", direction: "desc" },
                    dataArr      : Util.filterFieldData(dataArr as any, fldInfs, "mbrasNm", keyword),
                    maxRowNums   : [10, 20, 30],
                    theadTrHeight: 40,
                    tbodyTrHeight: 35,
                    // heightType : "fix",
                    bodyHeight   : 350,
                    remainArea   : true,
                    paginateClass: "pt10",
                    paginateStyle: {
                        buttonOnColor   : AppContext.boardThemeColor,
                        buttonWidth     : 22,
                        buttonHeight    : 24,
                        buttonMarginLeft: 1,
                        buttonMarginRight: 1,
                        fontSize        : 13,
                        color           : "#666666",
                        letterSpacing   : -0.8,
                        fontFamily      : "Pretendard-Regular",
                        borderRadius    : 3,
                    },
                    footerVsb    : true,
                    rowClickFunc : (item: any) => {
                        if (!checkWriteAvailable(item)) return;
                        selectMember(item.mbrasId);
                    },
                }}
            />

            <div className="dpFlx jcC mt20">
                <Button
                    width={90}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={15}
                    letterSpacing={-1}
                    variant="styCloseBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="닫기"
                    onClickFunc={() => {
                        setModalOpen(false);
                    }}
                />
            </div>
        </div>
    );
};

export default MbrasChangeSearchDialog;